import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=72b09506&scoped=true&"
import script from "./StatusLabel.vue?vue&type=script&lang=ts&"
export * from "./StatusLabel.vue?vue&type=script&lang=ts&"
import style0 from "./StatusLabel.vue?vue&type=style&index=0&id=72b09506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b09506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
